import React, { Suspense } from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { LoginLayout } from "../Authorization";
import Login from '../Authorization/Login'
import SignUp from '../Authorization/SignUp'
import ForgotPassword from '../Authorization/ForgotPassword'
import ResetPassword from '../Authorization/ResetPassword'
import OtherInfo from '../Authorization/Otherinfo'
import VerifyEmail from '../Authorization/VerifyEmail';
import LinkedInCallback from "../Authorization/SocialAuth/LinkedInCallback";
import ErrorFound from "../CommonComponents/ErrorFound";
import CollabratorConfirmAccount from "../Authorization/CollabratorConfirmAcc";
import RejectCollabratorRequest from "../Authorization/RejectCollabratorRequest";
import TakeuserEmail from "../Authorization/TakeuserEmail";
import ConnectAccount from "../Layouts/Main/ConnectAccount/ConnectAccount";
import RedirectLogin from "../Authorization/RedirectLogin";
import UgcSuitTiktok from "../CommonComponents/UgcSuitTiktok";
import UgcRight from "../Layouts/Main/UgcRight";
import { Helmet } from "react-helmet";
import Auth from "../Authorization/SocialAuth";
import PostRedirection from "../CommonComponents/PostRedirection";
import ProductLogin from "../Layouts/Header/Components/ProductLogin";
import OnBoarding from "../Layouts/Main/Onboarding/Index";
import MFALogin from "../Authorization/MFALogin";
import CalendlyRedirect from "../Authorization/CalendlyRedirect";


const UpdateResetPassword = (props) => {
    const params = useParams();
    return <ResetPassword prefix={props.prefix} params={params} />
}
const UpdateVerifyEmail = (props) => {
    const params = useParams();
    return <VerifyEmail prefix={props.prefix} params={params} history={props.history} />
}

const LoginBasePage = (props) => {

    const params = useParams();
    return (
        <>
            <Helmet>
                <script type="text/javascript">{`window._mfq = window._mfq || [];
                   (function() {
                        var mf = document.createElement("script");
                        mf.type = "text/javascript"; mf.defer = true;
                        mf.src = "//cdn.mouseflow.com/projects/5d24672d-901f-43be-86a6-a92685f165a6.js";
                        document.getElementsByTagName("head")[0].appendChild(mf);
                   })();`}
                </script>
            </Helmet>
            <Suspense fallback={<>loading</>}>
                {
                    <Routes>
                        <Route exact path="/postRedirection" element={<PostRedirection />} />

                        <Route exact path="/" element={<LoginLayout><Login prefix="/" history={props.history} /></LoginLayout>} />
                        <Route exact path="/accounts/register" element={<LoginLayout><SignUp prefix="/" history={props.history} /></LoginLayout>} />
                        {/* <Route exact path="/accounts/register" element={<CalendlyRedirect />} /> */}
                        <Route exact path="/accounts/login" element={<LoginLayout><Login prefix="/" history={props.history} /></LoginLayout>} />
                        <Route exact path="/accounts/forgotpassword" element={<LoginLayout><ForgotPassword prefix="/" activeProduct="0" /></LoginLayout>} />
                        <Route exact path="/accounts/resetpassword/:userId/:token" element={<LoginLayout><UpdateResetPassword prefix="/" /></LoginLayout>} />

                        <Route exact path="/socialwalls" element={<Navigate to={`/onboarding`} />} />
                        <Route exact path="/onboarding" element={<ErrorFound key={window.location.href}><OnBoarding /></ErrorFound>} />

                        <Route exact path="/accounts/otherinfo" element={<LoginLayout><OtherInfo prefix="/" history={props.history} /></LoginLayout>} />
                        <Route exact path="/accounts/extemail" element={<LoginLayout><TakeuserEmail prefix="/" history={props.history} /></LoginLayout>} />

                        <Route exact path="/verifyemail/:id" element={<UpdateVerifyEmail prefix="/" history={props.history} />} />
                        <Route exact path="/accounts/verifyemail/:id" element={<UpdateVerifyEmail prefix="/" history={props.history} />} />
                        <Route path="/display" element={<Navigate to={`/display/accounts/login`} />} />
                        <Route path="/widget" element={<Navigate to={`/widget/accounts/login`} />} />
                        <Route exact path="/tiktok/feeds/authcallback/" element={<ErrorFound key={window.location.href}><UgcSuitTiktok /></ErrorFound>} />

                        {/* ======== collabrator Acc confirmation  ======== */}
                        <Route exact path="/accounts/confirmaccount/:userId/:wallId" element={<LoginLayout><ErrorFound key={window.location.href}><CollabratorConfirmAccount prefix={`/`} /></ErrorFound></LoginLayout>} />
                        <Route exact path="/accounts/userdelete/:userId/:wallId" element={<ErrorFound key={window.location.href}><RejectCollabratorRequest prefix={`/`} /></ErrorFound>} />

                        {/* ======== connection socialAccount  ======== */}

                        <Route exact path="/:product/connection/:encodedId" element={<ErrorFound key={window.location.href}><ConnectAccount /></ErrorFound>} />
                        <Route exact path="/connection/:encodedId" element={<ErrorFound key={window.location.href}><ConnectAccount /></ErrorFound>} />
                        <Route exact path="/:product/redirectlogin/:token/:sessionToken/:admin" element={<RedirectLogin />} />
                        <Route exact path="/product/autologin/:token" element={<ErrorFound key={window.location.href}><ProductLogin /></ErrorFound>} />
                        <Route exact path="/autologin/:token" element={<ErrorFound key={window.location.href}><ProductLogin /></ErrorFound>} />

                        {/* ======== authentication  ======== */}

                        <Route exact path="/walls/authCallback" element={<ErrorFound key={window.location.href}><Auth /></ErrorFound>} />
                        <Route exact path="/feeds/authCallback" element={<ErrorFound key={window.location.href}><Auth /></ErrorFound>} />
                        <Route exact path="/feeds/authCallback_slack" element={<ErrorFound key={window.location.href}><Auth /></ErrorFound>} />

                        {/* ======== ugc-rights  ======== */}

                        <Route exact path="/:product/moderation/ugc_right/:requestId" element={<ErrorFound key={window.location.href}><UgcRight /></ErrorFound>} />
                        <Route exact path="/moderation/ugc_right/:requestId" element={<ErrorFound key={window.location.href}><UgcRight /></ErrorFound>} />
                        <Route exact path="/accounts/linkedinGet/" element={<LinkedInCallback key={window.location.href} />}></Route>
                        <Route exact path="/mfa_auth" element={<LoginLayout><MFALogin key={window.location.href} /></LoginLayout>}></Route>
                        <Route path="*" element={<Navigate to={`/accounts/login`} />} />

                    </Routes>

                }

            </Suspense >
        </>
    );
}
export default LoginBasePage
